import { useUpdateEffect } from '@xing-com/crate-entity-pages-common';
import { useErrorContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-error-context';
import { IconStar } from '@xing-com/icons';

import { useFeatureArticleMutation } from '../../../../hooks/use-feature-article-mutation';
import * as Styled from '../article-card-top.styles';

import type { ArticleControlButton } from './types';

export const ArticleFeatureButton: React.FC<ArticleControlButton> = ({
  article,
  disabled,
  onLoadingChange,
}) => {
  const { showError } = useErrorContext();

  const [makeArticleFeatured, { loading }] = useFeatureArticleMutation();

  useUpdateEffect(() => {
    onLoadingChange(loading);
  }, [loading]);

  const handleClick = async () => {
    try {
      await makeArticleFeatured({ input: { globalId: article.globalId } });
    } catch (error) {
      showError({ message: error.message, error });
    }
  };

  return (
    <Styled.Button
      data-testid={`ARTICLE-FEATURE-BUTTON-${article.id}`}
      icon={IconStar}
      size="small"
      variant="tertiary"
      disabled={disabled}
      loading={loading}
      onClick={handleClick}
    />
  );
};
